// extracted by mini-css-extract-plugin
module.exports = {"sticked-model-info":"ListingInfo_sticked-model-info__KYYFW","visible":"ListingInfo_visible__CqRqs"};